/**
 * Laufzeitbreite eines Fortschrittsbalkens ohne style-Attribut (Plan Regel 5):
 * feste Klassen wp0…wp100 aus theme/widths.css, ausgewählt über diese Tabelle
 * (nie per zusammengesetzter Zeichenkette).
 */
const WP_KLASSEN = [
  "wp0", "wp1", "wp2", "wp3", "wp4", "wp5", "wp6", "wp7", "wp8", "wp9",
  "wp10", "wp11", "wp12", "wp13", "wp14", "wp15", "wp16", "wp17", "wp18", "wp19",
  "wp20", "wp21", "wp22", "wp23", "wp24", "wp25", "wp26", "wp27", "wp28", "wp29",
  "wp30", "wp31", "wp32", "wp33", "wp34", "wp35", "wp36", "wp37", "wp38", "wp39",
  "wp40", "wp41", "wp42", "wp43", "wp44", "wp45", "wp46", "wp47", "wp48", "wp49",
  "wp50", "wp51", "wp52", "wp53", "wp54", "wp55", "wp56", "wp57", "wp58", "wp59",
  "wp60", "wp61", "wp62", "wp63", "wp64", "wp65", "wp66", "wp67", "wp68", "wp69",
  "wp70", "wp71", "wp72", "wp73", "wp74", "wp75", "wp76", "wp77", "wp78", "wp79",
  "wp80", "wp81", "wp82", "wp83", "wp84", "wp85", "wp86", "wp87", "wp88", "wp89",
  "wp90", "wp91", "wp92", "wp93", "wp94", "wp95", "wp96", "wp97", "wp98", "wp99",
  "wp100",
] as const;

/**
 * Fügt GANZE Klassenketten zusammen (z. B. Farbkette + Breitenklasse), nie Teile
 * eines Klassennamens. check:ui-preline erkennt `cx` und prüft jedes Argument einzeln.
 */
export function cx(...ketten: string[]): string {
  return ketten.join(" ");
}

/** Ganzzahliger Prozentwert 0…100 (gerundet, begrenzt). */
export function prozent(anteil: number, gesamt: number): number {
  if (!(gesamt > 0) || !(anteil > 0)) return 0;
  return Math.min(100, Math.max(0, Math.round((anteil / gesamt) * 100)));
}

/** Breitenklasse für einen Prozentwert 0…100. */
export function breiteKlasse(prozentwert: number): (typeof WP_KLASSEN)[number] {
  const i = Math.min(100, Math.max(0, Math.round(prozentwert)));
  return WP_KLASSEN[i]!;
}
